export class DashboardItem {
  constructor(public title: string, public description: string, public href: string, public icon: string) {}
}
